/* src/app/ai-sourcing/ai-sourcing-insights/ai-sourcing-insights.component.scss */
.ideal-talen-card {
  background-color: #F0F9FF;
  padding: 24px;
  margin-bottom: 5px;
}
.ideal-talen-card h1 {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: #484b59;
  margin-bottom: 5px;
}
.ideal-talen-card p {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.6;
  color: #484b59;
  margin-bottom: 0;
}
.ideal-talen-card p span {
  font-weight: 700;
}
.blue-text {
  color: #2e93a1;
}
.talent-data-card {
  width: 100%;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  padding: 8px 12px;
}
.dismiss-btn {
  width: 200px;
  background-color: #2E93A1;
  color: #ffffff;
}
.progress-text {
  font-size: 14px;
  font-weight: 500;
  color: #2E93A1;
  min-width: 35px;
}
.progress-container {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
}
.circular-progress {
  position: relative;
  width: 30px;
  height: 30px;
  margin: 0 8px;
}
.circular-progress svg {
  transform: rotate(-90deg);
}
.circular-progress-bg {
  fill: none;
  stroke: #e9ecef;
  stroke-width: 3;
}
.circular-progress-fill {
  fill: none;
  stroke: #2E93A1;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.3s ease;
}
.status-btn {
  padding: 0 6px 0 6px;
  border-radius: 3px;
}
.live-status {
  background-color: #dcf3d1;
  color: #229300;
  font-size: 14px;
  font-weight: 500;
}
.four-matrix {
  width: calc(100% - 12px);
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
}
.toggle-container .activebtn {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 11px;
  font-weight: 600;
}
.toggle-container .inactivebtn {
  background-color: #f7f7f7;
  color: #969696;
  border-radius: 3px;
  padding: 9px 11px;
  font-weight: 500;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
/*# sourceMappingURL=ai-sourcing-insights.component-BKTIUMOG.css.map */
